module.exports = __webpack_public_path__ + "static/media/employee.c8b4567e.png";